import { IPaymentTracking } from "../../interfaces/paymentTracking";
import {
  Timestamp,
  HeaderProfileComponent,
  Description,
} from "../../components/paymentCustomerComponents/InfomationComponent";
export default function convertDataToInfo(
  data: IPaymentTracking[],
  fetchData: () => void
) {
  return data.map((item: IPaymentTracking) => [
    <HeaderProfileComponent
      pictureUrl={item.imageUrl}
      displayName={item.displayName}
      productName={item.product.productName}
      isCoupon={item.isCoupon}
      refPayment={item.refPayment}
      status={item.status}
      uid={item.uid}
      bookingId={item.bookingId}
      fetchData={fetchData}
    />,
    <Description description={item.descriptions} doctorId={item.doctorId} />,
    <Timestamp time={item.timeStamp} />,
  ]);
}
